import { http, HttpResponse } from "msw";
import { BackendId } from "@libs/appliance_common";
import { NodeType } from "@libs/appliance_common";
import { getMockOidcConfig } from "./auth";
/** Build auth_methods and oidc_config based on current mock state. */ function oidcFields() {
    const cfg = getMockOidcConfig();
    if (cfg) {
        return {
            auth_methods: [
                BackendId.Local,
                BackendId.LDAP,
                BackendId.OIDC
            ],
            oidc_config: {
                server_url: cfg.server_url,
                realm: cfg.realm,
                auth_client_id: cfg.auth_client_id
            }
        };
    }
    return {
        auth_methods: [
            BackendId.Local,
            BackendId.LDAP
        ],
        oidc_config: null
    };
}
export const enabledHandler = http.get("/api/admin/node-conf", ()=>{
    const res = {
        features: {
            entropy: true,
            qdea: true,
            qseed: true,
            ipsec_tunnels: true,
            etsi_014: true,
            blast_endpoints: true,
            control_plane: true
        },
        node_type: NodeType.QEA,
        ...oidcFields(),
        control_plane_url: null
    };
    return HttpResponse.json(res);
});
export const disabledHandler = http.get("/api/admin/node-conf", ()=>{
    const res = {
        features: {
            entropy: false,
            qdea: false,
            qseed: false,
            ipsec_tunnels: false,
            etsi_014: false,
            blast_endpoints: false,
            control_plane: false
        },
        node_type: NodeType.QEA,
        ...oidcFields(),
        control_plane_url: "https://control-plane.example.com"
    };
    return HttpResponse.json(res);
});
// Handler for node NOT in cluster
export const nodeNotInClusterHandler = http.get("/api/admin/node-conf", ()=>{
    const res = {
        features: {
            entropy: true,
            qdea: true,
            qseed: true,
            ipsec_tunnels: true,
            etsi_014: true,
            blast_endpoints: true,
            control_plane: false
        },
        node_type: NodeType.QEA,
        ...oidcFields(),
        control_plane_url: null
    };
    return HttpResponse.json(res);
});
// Handler for node IN cluster as control plane
export const nodeAsControlPlaneHandler = http.get("/api/admin/node-conf", ()=>{
    const res = {
        features: {
            entropy: true,
            qdea: true,
            qseed: true,
            ipsec_tunnels: true,
            etsi_014: true,
            blast_endpoints: true,
            control_plane: true
        },
        node_type: NodeType.QEA,
        ...oidcFields(),
        control_plane_url: null
    };
    return HttpResponse.json(res);
});
// Handler for node IN cluster as worker node
export const nodeAsWorkerHandler = http.get("/api/admin/node-conf", ()=>{
    const res = {
        features: {
            entropy: true,
            qdea: true,
            qseed: true,
            ipsec_tunnels: true,
            etsi_014: true,
            blast_endpoints: true,
            control_plane: false
        },
        node_type: NodeType.QEA,
        ...oidcFields(),
        control_plane_url: "https://control-plane.example.com"
    };
    return HttpResponse.json(res);
});
// QEA-only customer: entropy + qseed enabled, BLAST/IPsec/QDEA/ETSI disabled
export const qeaOnlyHandler = http.get("/api/admin/node-conf", ()=>{
    const res = {
        features: {
            entropy: true,
            qdea: false,
            qseed: true,
            ipsec_tunnels: false,
            etsi_014: false,
            blast_endpoints: false,
            control_plane: true
        },
        node_type: NodeType.QEA,
        ...oidcFields(),
        control_plane_url: null
    };
    return HttpResponse.json(res);
});
export default enabledHandler;
